import { render, staticRenderFns } from "./crmlayout.vue?vue&type=template&id=67a509de&"
import script from "./crmlayout.vue?vue&type=script&lang=js&"
export * from "./crmlayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports